// removed by extract-text-webpack-plugin
module.exports = {"root":"root__1ZuD9","heart":"heart__3nJ9L","back":"back__32PsL"};


//////////////////
// WEBPACK FOOTER
// ./components/NextArrow/style.css
// module id = GA8P
// module chunks = 0